<template>
  <div class="page-box">
    <!--头部-->
    <headerBar />
    <siteNav :selectedIndex="selectedIndex" />
    <!--头部end-->

    <!---->
    <div class="center-box">
      <div class="qualityControl-box">
        <div class="crumbs">首页 > “向错误学习”平台</div>
        <div class="user-forum-details">
          <div class="forum-top">
            <img v-if="details.avatar && details.avatar.url != undefined" :src="details.avatar.url" />
            <img v-else src="@/assets/images/defaultHead.png" />
            <div class="forum-user">
              <div class="user-name">{{ details.userNickName }}</div>
              <div class="time">{{ details.createTimeFormat }}</div>
            </div>
          </div>
          <div class="forum-text">{{ details.noteContent }}</div>
          <div class="forum-img" :class="{ active: details.noteImages.length > 2 }">
            <!-- <img v-for="(img, idx) in details.noteImages" :key="idx" :src="img.url" alt="img" /> -->
            <div class="forum-img-item" v-for="(img, idx) in details.noteImages" :key="idx">
              <el-image :src="img.url" :preview-src-list="showImgList(details.noteImages)" fit="contain"
                @click="handlePreview"></el-image>
            </div>
          </div>
          <div class="forum-bottom">
            <div class="operate-li" @click="toggleFirst">
              <img :src="details.likeStatus ? require('@/assets/images/f5.png') : require('@/assets/images/f1.png')" />
              <span>{{ details.likeCount }}</span>
            </div>
            <div class="operate-li" @click="toggleThird">
              <img
                :src="details.collectionStatus ? require('@/assets/images/f6.png') : require('@/assets/images/f3.png')" />
              <span>{{ details.collectCount }}</span>
            </div>
            <div class="operate-li" @click="toggleShare">
              <img src="@/assets/images/f4.png" alt="" />
              <span>{{ details.shareCount }}</span>
            </div>
            <div class="operate-li" @click="showComment">
              <img src="@/assets/images/f2.png" alt="" />
              <span>{{ details.commentCount }}</span>
            </div>
          </div>
        </div>
        <div class="forum-comment-list">
          <div class="forum-comment-title">全部评论</div>
          <div class="forum-comment-content">
            <template v-if="commentList.length > 0">
              <div class="forum-comment-item" v-for="(item, index) in commentList" :key="index">
                <div class="forum-comment-header">
                  <img v-if="item.avatar && item.avatar.url != undefined" :src="item.avatar.url" alt="">
                  <img v-else src="@/assets/images/defaultHead.png" />
                  <span>{{ item.nickname ? item.nickname : item.nickName }}</span>
                </div>
                <div class="forum-comment-text">
                  {{ item.content }}
                </div>
                <div class="forum-comment-bottom">
                  {{ item.createTimeFormat }}
                </div>
              </div>
            </template>
            <empty class="empty-margin" v-if="commentList.length <= 0"></empty>
            <div class="pagination-box">
              <el-pagination class="paging" background :current-page="page.number" :page-sizes="[10, 20, 30, 40]"
                :page-size="page.limit" layout="prev, pager, next, sizes" :total="page.total" @size-change="sizeChange"
                @current-change="currentChange" @prev-click="prevClick" @next-click="nextClick"></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!---->
    <commentInput :showCommentPop.sync="showCommentPop" :id="id" isForum="1"></commentInput>
    <!--页脚-->
    <footer-bar></footer-bar>
    <!--页脚end-->
  </div>
</template>

<script>
import headerBar from "@/components/base/headerBar";
import siteNav from "@/components/base/siteNav";
import FooterBar from "../../components/base/footerBar";
import { getForumDetails, getForumComment, setGiveALike, setCollection, shareForumPost } from '@/api/forum'
import commentInput from "@/components/base/commentInput"
import empty from "@/components/empty/index";

export default {
  name: "ForumCenterDetails",
  components: { FooterBar, headerBar, siteNav, commentInput, empty },
  data() {
    return {
      selectedIndex: 0,
      id: '',
      details: {
        noteImages: []
      },
      showCommentPop: false,
      commentList: [],
      page: {
        number: 1,
        limit: 10,
        total: 0,
      },
    }
  },
  methods: {
    showImgList(value) {
      let temporary = JSON.parse(JSON.stringify(value))
      let temporaryTwo = []
      temporary.forEach(item => {
        temporaryTwo.push(item.url)
      })
      return temporaryTwo
    },
    handlePreview(event) {
      event.stopPropagation();
    },
    showComment() {
      this.showCommentPop = true
    },
    getForumDetailsFun() {
      getForumDetails({
        id: this.id,
      }).then(res => {
        if (res.code == "A00000") {
          this.details = res.data[0]
        }
      })
    },
    getForumComment() {
      getForumComment({
        noteId: this.id,
        number: this.page.number,
        limit: this.page.limit,
      }).then(res => {
        if (res.code == "A00000") {
          this.commentList = res.data
          this.page.total = res.totalCount
        }
      })
    },
    toggleFirst() {
      setGiveALike({
        noteId: this.id,
      }).then(res => {
        if (res.code == "A00000") {
          let temporary = JSON.parse(JSON.stringify(this.details))
          temporary.likeStatus = !temporary.likeStatus
          temporary.likeCount = temporary.likeStatus ? (1 + temporary.likeCount) : (temporary.likeCount - 1)
          this.details = temporary
        }
      })
    },
    toggleThird() {
      setCollection({
        noteId: this.id,
      }).then(res => {
        if (res.code == "A00000") {
          let temporary = JSON.parse(JSON.stringify(this.details))
          temporary.collectionStatus = !temporary.collectionStatus
          temporary.collectCount = temporary.collectionStatus ? (1 + temporary.collectCount) : (temporary.collectCount - 1)
          this.details = temporary
        }
      })
    },
    toggleShare() {
      shareForumPost({
        noteId: this.id,
      }).then(res => {
        if (res.code == "A00000") {
          const url = `${window.location.href.split("#")[0]}#/ForumCenterDetails/${this.id}` // 获取当前页面的URL
          navigator.clipboard.writeText(url).then(() => {
            // 复制成功后的回调
            let temporary = JSON.parse(JSON.stringify(this.details))
            temporary.shareCount = (1 + temporary.shareCount)
            this.details = temporary
            this.$message.success("已复制链接!")
          }).catch(err => {
            // 复制失败的处理
            console.error('复制失败:', err);
          });
        }
      })
    },
    sizeChange(value) {
      this.page.number = 1
      this.page.limit = value
      this.getForumComment()
    },
    currentChange(value) {
      this.page.number = value
      this.getForumComment()
    },
    prevClick(value) {
      this.page.number = value
      this.getForumComment()
    },
    nextClick(value) {
      this.page.number = value
      this.getForumComment()
    },
  },
  mounted() {
    this.id = this.$route.params.id
    this.getForumDetailsFun()
    this.getForumComment()
  },
}
</script>

<style lang="less" scoped>
.center-box {
  padding-bottom: 20px;
}

.user-forum-details {
  margin-top: 26px;
  background: #fff;
  border-radius: 6px;
  margin-bottom: 24px;
  padding: 14px 20px;

  .forum-bottom {
    display: flex;
    align-items: center;
    margin-top: 18px;

    .operate-li {
      cursor: pointer;
      width: 93px;
      display: flex;
      align-items: center;

      img {
        width: 14px;
        margin-right: 4px;
      }

      span {
        color: #525252;
        font-size: 12px;
      }
    }
  }

  .forum-img.active {
    img {
      height: 88px;
    }
  }

  .forum-img {
    display: flex;
    align-items: center;
    margin-top: 14px;

    .forum-img-item {
      height: 220px;
      margin-right: 12px;

      /deep/.el-image {
        height: 220px;
      }
    }
  }

  .forum-text {
    color: #525252;
    font-size: 14px;
    line-height: 22px;
    margin-top: 18px;
    text-align: left;
  }

  .forum-top {
    display: flex;
    align-items: center;

    .forum-user {
      text-align: left;
      
      .user-name {
        color: #404040;
        font-size: 14px;
        line-height: 14px;
      }

      .time {
        color: #A3A3A3;
        font-size: 12px;
        margin-top: 4px;
      }
    }

    img {
      width: 34px;
      height: 34px;
      border-radius: 50%;
      margin-right: 6px;
      overflow: hidden;
    }
  }
}

.forum-comment-list {
  background: #fff;
  border-radius: 6px;
  padding: 6px 16px 16px;

  .forum-comment-title {
    border-bottom: 1px solid #E6E6E6;
    line-height: 50px;
    color: #222222;
    font-size: 22px;
    font-weight: 600;
    position: relative;
    text-align: left;
    margin-bottom: 32px;
  }

  .forum-comment-title::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    height: 3px;
    width: 112px;
    background-color: #BD181E;
  }

  .forum-comment-content {
    text-align: left;

    .forum-comment-item {
      padding: 20px 18px;
      border-bottom: 0.5px solid #E5E6EB;

      .forum-comment-header {
        display: flex;
        align-items: center;
        margin-bottom: 10px;

        span {
          font-size: 14px;
          color: #222222;
          font-weight: 600;
        }

        img {
          width: 26px;
          height: 26px;
          margin-right: 6px;
          vertical-align: bottom;
          border-radius: 50%;
        }
      }

      .forum-comment-text {
        margin-bottom: 12px;
        color: #222222;
        font-size: 15px;
        font-weight: 600;
      }

      .forum-comment-bottom {
        color: #999999;
        font-weight: 600;
        font-size: 12px;
      }
    }
  }
}

.pagination-box {
  width: 100%;
  text-align: center;
}

/deep/.el-pagination button {
  border: 1px solid var(---, rgba(0, 0, 0, 0.15)) !important;
  background: #fff !important;
  width: 32px;
  height: 32px;
  color: rgba(0, 0, 0, 0.45) !important;
  line-height: 30px;
}

/deep/.el-pager li {
  border: 1px solid var(---, rgba(0, 0, 0, 0.15)) !important;
  background: #fff !important;
  width: 32px;
  height: 32px;
  border-right: 2px;
  color: rgba(0, 0, 0, 0.45) !important;
  line-height: 30px;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #BD181E !important;
  color: rgba(255, 255, 255, 0.65) !important;
}

.empty-margin {
  margin: 40px 0;
}
</style>


// WEBPACK FOOTER //
// src/views/ForumCenter/details.vue